export default "__VITE_ASSET__Cd7UK$IS__"